export const isPdfFile = (fileName?: string | null, mimeType?: string): boolean => {
  if (mimeType?.includes("pdf")) {
    return true;
  }
  return fileName ? fileName.toLowerCase().endsWith(".pdf") : false;
};

export const isImageFile = (fileName?: string | null, mimeType?: string): boolean => {
  if (mimeType?.startsWith("image/")) {
    return true;
  }
  return fileName ? /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(fileName) : false;
};

export const canViewInline = (fileName?: string | null, mimeType?: string): boolean => {
  return isPdfFile(fileName, mimeType) || isImageFile(fileName, mimeType);
};

